<template>
  <div>
    <v-row no-gutters justify="start">
      <div class="side-content-small ml-6">
        <v-row no-gutters align="center" class="content-header">
          <v-btn class="n-white-btn n-small-btn px-2 mr-2" @click="backToClientsList()">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-col class="text-truncate">
            <div class="font-weight-bold text-truncate">
              {{ client.name }}
            </div>
          </v-col>
        </v-row>
        <div class="left-admin-nav">
          <ul>
            <li
              v-for="(item, i) in items"
              :key="i"
              :class="{ active: item.isActive }"
              @click="goTo(item.path)"
            >
              <v-icon class="float-right">keyboard_arrow_right</v-icon>
              <div>{{ item.text }}</div>
            </li>
          </ul>
        </div>
      </div>
      <v-col align="center" class="pa-0 mx-6">
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: `SettingsMainLayout`,
  data: () => ({
    rawItems: [
      {
        text: `Infos générales`,
        path: `/settings/clients/:clientId/infos`,
        isForAggregatorClient: true,
      },
      {
        text: `Sites`,
        path: `/settings/clients/:clientId/sites`,
        isForAggregatorClient: false,
      },
      {
        text: `Utilisateurs`,
        path: `/settings/clients/:clientId/users`,
        isForAggregatorClient: false,
      },
      {
        text: `Interventions récurrentes`,
        path: `/settings/clients/:clientId/recurrent-interventions`,
        isForAggregatorClient: true,
      },
      {
        text: `Équipements`,
        path: `/settings/clients/:clientId/equipments`,
        isPreviewFeature: true,
        isForAggregatorClient: false,
      },
      {
        text: `Contrats de maintenance`,
        path: `/settings/clients/:clientId/maintenance-contracts`,
        isPreviewFeature: true,
        isForAggregatorClient: false,
      },
    ],
  }),
  computed: {
    ...mapState(`model/client`, {
      company: `company`,
      client: `currentAdminClient`,
    }),
    ...mapState(`ui/mainLayout`, [`isDemoApp`, `isLocalApp`]),
    items() {
      return _.chain(this.rawItems)
        .filter(item => _.isUndefined(item.isPreviewFeature) || this.isDemoApp || this.isLocalApp)
        .filter(item => item.isForAggregatorClient || this.client?.slug === ``)
        .map(item => ({
          ...item,
          isActive: this.routePath === item.path,
        }))
        .value();
    },
    routePath() {
      return this.$route.path.replace(/clients\/\d+/g, `clients/:clientId`);
    },
  },
  methods: {
    backToClientsList() {
      this.$store.commit(`ui/clientsList/SET_KEEPING_PREVIOUS_STATE`, true);
      this.$router.push(`/settings/clients`);
    },
    goTo(path) {
      if (path !== this.routePath) {
        const realPath = path.replace(/:clientId/, this.$route.params.clientId);
        this.$router.push(realPath);
      }
    },
  },
  beforeMount() {
  },
};
</script>

<style lang="scss">
</style>
